/**
 * Non Post Order Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';

// Context
import AuthContext from '../../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';
import { getOrderWithIdAction, updateOrderStatusActions } from '../actions';
import Client from 'client-sdk/src/client';
import { UpdateOrderDeliveryCost } from 'client-sdk/src/orders/orders';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError,
} from '../selectors';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../../theme';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  IconButton,
  TextField,
  MenuItem,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';

// Icon
import Icon from '@mdi/react';
import {
  mdiCalendar,
  mdiAccountOutline,
  mdiArrowRight,
  mdiPencilOutline,
  mdiClose,
  mdiPhoneOutline,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiCityVariantOutline,
  mdiSendCircleOutline,
  mdiWeight,
  mdiRuler,
  mdiCounter,
  mdiPaperRollOutline,
  mdiPackageVariant,
  mdiLoading,
  mdiAccountCircle,
  mdiPlusBox,
} from '@mdi/js';

// Helper
import {
  translate,
  formaterPhoneNumber,
  uintToString,
} from '../../../utils/helpers';
import jMoment from 'moment-jalaali';
import handleNotfication from '../../../utils/handleNotfication';

// Type
import { Status } from '../interfaces';
import { SelectorProps, Props } from '../../orderDetails/interfaces';
import { mdiText } from '@mdi/js/commonjs/mdi';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../../utils/handleError';
import MapPosition from './mapPosition';
import Modal from '../../../components/Modal';
import MotorPlate from '../../drivers/motorPlate';
import Plate from '../../drivers/plate';
import { Switch } from '@material-ui/core';
import WebSoketClient from 'client-sdk/src/WebSoketClient';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    secondDestination: {
      color: '#4aa8ff',
      '&:hover': {
        backgroundColor: 'transparent',
        color: '#4594db',
      },
      '& .MuiButton-label': {
        display: 'flex',
        justifyContent: 'flex-start',
      },
    },
    requestButton: {
      backgroundColor: '#4aa8ff',
      marginTop: '20px',
      width: '100%',
      color: 'white',
      '&:hover': {
        backgroundColor: '#4594db',
      },
    },
    requestDetailCard: {
      borderRadius: '10px',
      zIndex: 1000,
      backgroundColor: 'white',
      padding: '20px',
      position: 'absolute',
      top: '10px',
      left: '10px',
      width: '300px',
      '& > h4': {
        marginTop: 0,
      },
      '& .inputText': {
        margin: '20px 0',
      },
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    borderBottom: {
      paddingBottom: '20px',
      borderBottom: '3px solid #ff1111',
    },
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    select: {
      '& .MuiInputLabel-outlined': {
        transform: 'translate(11px, 10px) scale(1)',
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        transform: 'translate(14px,-6px) scale(0.75)',
      },
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
  })
);

export function AlopeykRequest(props: any) {
  const token = localStorage.getItem('token') || '';
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [openDeleteItem, setOpenDeleteItem] = React.useState(false);
  const [latLng, setLatLng] = useState({ lat: 0, lng: 0 } as {
    lat: number;
    lng: number;
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [driverStatus, setDriverStatus] = useState('');
  const [loadingDriver, setLoadingDriver] = useState(false);
  const [hasSecondDestination, setHasSecondDestination] = useState(false);
  const [item, setItem] = useState({} as any);
  const [description, setDescription] = useState('');
  const [sourceName, setSourceName] = useState('');
  const [destinationName, setDestinationName] = useState('');
  const [stopTime, setStopTime] = useState('');
  const [waypoints, setWaypoints] = useState([{ lat: 35.6700926, lon: 51.2933106 }, { lat: 35.6700855, lon: 51.2942279 }] as any);
  const [request3PLError, setRequest3PLError] = useState('');
  const [request3PLLoading, setRequest3PLLoading] = useState(false);
  const [order3PL, setOrder3PL] = useState({} as any);
  const [driver, setDriver] = useState({} as any);
  const [totalPrice, setTotalPrice] = useState(32500);
  const [openAlopeykRequest, setOpenAlopeykRequest] = useState(
    false as boolean
  );
  const { register, handleSubmit, setValue, getValues } = useForm({});
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [orderDeliveryCost, setOrderDeliveryCost] = useState<null | number>(
    null
  );
  const classes = useStyles();

  useEffect(() => {
    getOrder();
  }, []);

  // useEffect(() => {
  //   getStreamLiveLocation();
  // }, []);

  const cancel3PLRequest = () => {
    cancelOrder3PL();
  };

  const cancelOrder3PL = async () => {
    const payload = {
      id: props.id,
      body: { description: '' },
      callback: () => {
        cancelRequest();
      },
    };
    try {
      setLoading(true);
      const { response, callback } = await ordersRepository.cancel3PLItems({
        payload,
      });
      setOrder3PL(response.data);
      handleNotfication('درخواست پیک مورد نظر با موفقیت لغو شد ', 'success');
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const cancelRequest = () => {
    setOpenAlopeykRequest(false);
    setDriver({});
  };

  const handlerDriver = () => {
    setOpenAlopeykRequest(true);
    setLoadingDriver(true);
    makeUpdate3PL();
  };

  useEffect(() => {
    if (props.order?.deliveryCost) {
      setOrderDeliveryCost(props.order?.deliveryCost);
    }
  }, [props.order]);

  const getOrder3PL = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const { response, callback } = await ordersRepository.getOrder3PL({
        payload,
      });
      setOrder3PL(response.data);
      setDriver({
        name: response.data.agentName,
        phoneNumber: response.data.agentPhoneNumber,
        imageUrl: '',
        vehicleClass: 'MOTORCYCLE',
        secondDestination: false,
        plate: response.data.vehiclePlateNumber,
        timeToDeliver: response.data.duration,
        paymentType: 'CASH',
      });
      setDriverStatus(response.data.status);
      callback && callback();
    } catch (error) {
      setRequest3PLError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };

  const makeUpdate3PL = () => {
    const tpl = {
      ...order3PL,
      sourceLat: waypoints[0].lat,
      sourceLon: waypoints[0].lon,
      destinationLat: latLng.lat,
      destinationLon: latLng.lng,
    };
    updateOrder3PL({
      body: tpl,
      callback: () => {
        sendRequestTo3PL();
      },
    });
  };

  const sendRequestTo3PL = () => {
    const { id } = props;
    sendRequestOrder3PL({
      id,
    });
  };

  const updateOrder3PL = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const { response, callback } = await ordersRepository.updateOrder3PL({
        payload,
      });
      callback && callback();
    } catch (error) {
      setRequest3PLError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };

  const sendRequestOrder3PL = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const { response, callback } = await ordersRepository.sendRequestOrder3PL({
        payload,
      });
      setOrder3PL(response.data);
      callback && callback();
    } catch (error) {
      setRequest3PLError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };

  // useEffect(() => {
  //   if (order3PL.sourceLat || order3PL.sourceLat === 0) {
  //     setWaypoints([{ lat: order3PL.sourceLat, lon: order3PL.sourceLon }]);
  //     order3PL.destinationLat &&
  //       order3PL.destinationLat.toString().includes('.') &&
  //       setWaypoints([
  //         { lat: order3PL.sourceLat, lon: order3PL.sourceLon },
  //         { lat: order3PL.destinationLat, lon: order3PL.destinationLon },
  //       ]);
  //     order3PL.destinationLat &&
  //       !order3PL.destinationLat.toString().includes('.') &&
  //       setWaypoints([
  //         { lat: order3PL.sourceLat, lon: order3PL.sourceLon },
  //         { lat: order3PL.sourceLat + 0.01, lon: order3PL.sourceLon + 0.01 },
  //       ]);
  //     !order3PL.destinationLat &&
  //       setWaypoints([
  //         { lat: order3PL.sourceLat, lon: order3PL.sourceLon },
  //         { lat: order3PL.sourceLat + 0.01, lon: order3PL.sourceLon + 0.01 },
  //       ]);
  //   }
  // }, [order3PL]);

  const getRequestOrder3PL = () => {
    const { id, orderId } = props;
    getOrder3PL({ id });
  };

  const getOrder = () => {
    const { id, orderId } = props;
    getOrder3PL({ id });
    props.orderWithIdActionDispatch(orderId);
  };

  const handleChangeDeliveryCost = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOrderDeliveryCost(e.target?.value!);
  };

  const addSecondDestination = () => {
    setHasSecondDestination(true);
  };

  const changeStatusOrder = () => {
    const { id } = props;
    props.updateOrderStatusDispatch({
      id: props.order.id,
      body: previewState.replace(/"/g, ''),
      pagination: {},
      callback: () => props.orderWithIdActionDispatch(id),
    });
    handleClose();
  };

  const getStreamLiveLocation = () => {
    const WSClient = new WebSoketClient().execute();
    WSClient.on('connect', () => {
      WSClient.subscribe('roles/LOGISTICS_ADMIN', (data: any, err: any) => { });
    });
    WSClient.on('message', (topic: any, mes: any) => {
      const parsMessage = uintToString(mes);
      if (parsMessage && parsMessage.id === props.id) {
        parsMessage.type === 'STATUS_UPDATE' &&
          setDriverStatus(parsMessage.newStatus);
        if (
          parsMessage.type === 'STATUS_UPDATE' &&
          parsMessage.newStatus === 'COURIER_ACCEPTED'
        ) {
          setLoadingDriver(false);
          setOpenAlopeykRequest(false);
          getRequestOrder3PL();
        }
        if (
          parsMessage.type === 'STATUS_UPDATE' &&
          parsMessage.newStatus === 'SEARCHING_COURIER_EXPIRED'
        ) {
          setLoadingDriver(false);
          setOpenAlopeykRequest(false);
        }
      }
    });
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  const cancelItem = (item: any) => {
    setItem(item);
    setOpenDeleteItem(true);
  };

  const handleCloseDialog = () => {
    setOpenDeleteItem(false);
  };

  const handleChangeLocation = (locations: any) => {
    const latLangs = locations.map((location: any) => {
      return { lat: location.latLng.lat, lon: location.latLng.lng };
    });
    setWaypoints(latLangs);
    setSourceName(locations[0].name);
    setDestinationName(locations[1].name);
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };
  const submitOrderDeliveryCost = async () => {
    try {
      const { id } = props;
      const makeRequest = new UpdateOrderDeliveryCost()
        .id(id)
        .data(orderDeliveryCost)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication('کد پیگیری پست با موفقیت ثبت شد', 'success');
      props.orderWithIdActionDispatch(id);
    } catch (err) {
      handleNotfication(
        'تغییر کد پیگیری پست ثبت نشد دوباره تلاش کنید',
        'error'
      );
    }
  };
  return (
    <Grid className={classes.root}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {'نام سفارش‌دهنده:  '}
              </span>

              <span>{props.order.customerName}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPhoneOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'شماره همراه سفارش‌دهنده:  '}
              </span>
              <span>
                {formaterPhoneNumber(props.order.customerMobileNumber)}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'استان:  '}
              </span>
              <span>{formaterPhoneNumber(props.order.customerProvince)}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCityVariantOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'شهر:  '}
              </span>
              <span>{formaterPhoneNumber(props.order.customerCity)}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'کد پستی:  '}
              </span>
              <span>{formaterPhoneNumber(props.order.customerZipCode)}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPackageVariant}
                  size={1}
                  className={classes.icon}
                />
                {'تعداد بسته:  '}
              </span>
              <span>{props.order?.orderPackages?.length}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {'تاریخ تحویل سفارش:  '}
              </span>
              <span>
                {props.order.deliveryDate &&
                  `${jMoment(props.order.deliveryDate, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}`}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarClock}
                  size={1}
                  className={classes.icon}
                />
                {'ساعت تحویل سفارش:  '}
              </span>
              <span>
                {`${jMoment(props.order.deliveryStartTime, 'HH:mm:ss')
                  .locale('fa')
                  .format('HH:mm')}`}
                {` - ${jMoment(props.order.deliveryEndTime, 'HH:mm:ss')
                  .locale('fa')
                  .format('HH:mm')}`}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12} sm={7}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {'آدرس سفارش‌دهنده:  '}
              </span>
              <span>
                {props.order.customerAddress && props.order.customerAddress}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={5}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPaperRollOutline}
                  size={1}
                  className={classes.icon}
                />
                {'توضیحات:  '}
              </span>
              <span>{props.order.description && props.order.description}</span>
            </div>
          </Grid>

          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiSendCircleOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'نوع ارسال:  '}
              </span>
              <span>
                {translate(props.order?.deliveryType)}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {'تعداد آیتم های سفارش:  '}
              </span>
              <span>{props.order?.items?.length}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWeight} size={1} className={classes.rtlIcon} />
                {'وزن سفارش:  '}
              </span>
              <span>{order3PL.weight}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiRuler} size={1} className={classes.rtlIcon} />
                {'ابعاد سفارش:  '}
              </span>
              <span dir="ltr">
                {order3PL.length
                  ? `${order3PL.length} x ${order3PL.width} x ${order3PL.height}`
                  : '-'}
              </span>
            </div>
          </Grid>
        </Grid>
      </Paper>

      <Grid item xs={12} style={{ position: 'relative' }}>
        {waypoints.length !== 0 && (
          <MapPosition
            style={{ height: '800px' }}
            zoom={14}
            center={{ lat: waypoints[0]?.lat, lng: waypoints[0]?.lon }}
            position={latLng}
            waypoint={waypoints}
            handleChangeLocation={handleChangeLocation}
            setLatlng={(latLng: { lat: number; lng: number }) => {
              setLatLng(latLng);
            }}
          />
        )}
        <Grid className={classes.requestDetailCard}>
          {(!driverStatus || driverStatus === 'NOT_REGISTERED') && (
            <h4>{'درخواست پیک'}</h4>
          )}
          {driverStatus && !driver.name && driverStatus !== 'NOT_REGISTERED' && (
            <>
              <Grid>
                <span>{'وضعیت: '}</span>
                <strong>{translate(driverStatus, 'tplStatus')}</strong>
              </Grid>
              <Divider className={classes.divider} />
            </>
          )}
          {driver.name && (
            <>
              <Grid
                style={{ margin: 0, flexGrow: 1 }}
                container
                alignItems="center"
                spacing={4}
              >
                <Grid item>
                  {driver.imageUrl && (
                    <img
                      style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                      }}
                      src={driver.imageUrl}
                      alt={driver.name}
                    />
                  )}
                  {!driver.imageUrl && (
                    <Icon path={mdiAccountCircle} size={2} />
                  )}
                </Grid>
                <Grid item>
                  <div>{driver.name}</div>
                  <div>{formaterPhoneNumber(driver.phoneNumber)}</div>
                </Grid>
              </Grid>
              <Divider className={classes.divider} />
              <Grid>
                <span>{'وضعیت: '}</span>
                <strong>{translate(driverStatus, 'tplStatus')}</strong>
              </Grid>
              <Divider className={classes.divider} />
              <Grid>
                {driver.vehicleClass === 'MOTORCYCLE' ? (
                  <MotorPlate
                    getNumber={number => setValue('plateNumber', number)}
                    number={driver.plate}
                  />
                ) : (
                  <Plate
                    getNumber={number => setValue('plateNumber', number)}
                    number={driver.plate}
                  />
                )}
              </Grid>
            </>
          )}
          <form>
            <div className="inputText">
              <TextField
                fullWidth
                id="serial"
                name="serial"
                size="small"
                InputLabelProps={{
                  shrink: !!sourceName,
                }}
                variant="outlined"
                value={sourceName}
                inputRef={register({
                  required: true,
                })}
                autoFocus
                label="مبدا"
              />
            </div>
            <div className="inputText">
              <TextField
                fullWidth
                id="serial"
                name="serial"
                size="small"
                InputLabelProps={{
                  shrink: !!destinationName,
                }}
                variant="outlined"
                value={destinationName}
                inputRef={register({
                  required: true,
                })}
                autoFocus
                label="مقصد"
              />
            </div>
            {driver.name && driver.secondDestination && (
              <>
                <div>
                  {!hasSecondDestination ? (
                    <Button
                      className={classes.secondDestination}
                      onClick={addSecondDestination}
                      fullWidth
                      variant="text"
                      startIcon={
                        <Icon path={mdiPlusBox} color="#4aa8ff" size={1} />
                      }
                    >
                      {'افزودن مقصد دوم'}
                    </Button>
                  ) : (
                    <div className="inputText">
                      <TextField
                        fullWidth
                        id="serial"
                        name="serial"
                        size="small"
                        variant="outlined"
                        inputRef={register({
                          required: true,
                        })}
                        autoFocus
                        label="مقصد دوم"
                      />
                    </div>
                  )}
                </div>
                <Divider className={classes.divider} />
                <span className={classes.select} style={{ width: '100%' }}>
                  <TextField
                    select
                    fullWidth
                    id="transportationType"
                    name="transportationType"
                    inputProps={{
                      name: 'transportationType',
                      id: 'transportationType',
                    }}
                    label="زمان توقف"
                    value={stopTime}
                    variant="outlined"
                    onChange={e => setStopTime(e.target.value)}
                    className={classes.textInput}
                    inputRef={register({ required: true })}
                  >
                    <MenuItem value={'5-10'}>5 تا 10 دقیقه</MenuItem>
                    <MenuItem value={'10-15'}>10 تا 15 دقیقه</MenuItem>
                    <MenuItem value={'15-20'}>15 تا 20 دقیقه</MenuItem>
                    <MenuItem value={'20-25'}>20 تا 25 دقیقه</MenuItem>
                    <MenuItem value={'25-30'}>25 تا 30 دقیقه</MenuItem>
                  </TextField>
                </span>
                <Divider className={classes.divider} />
                <Grid
                  style={{ margin: 0 }}
                  container
                  justify="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <span>{'برگشت دارد'}</span>
                  </Grid>
                  <Grid item>
                    <Switch />
                  </Grid>
                </Grid>
              </>
            )}
            <Divider className={classes.divider} />
            <Grid
              style={{ margin: 0 }}
              container
              justify="space-between"
              alignItems="center"
            >
              <Grid item>
                <span>{'هزینه'}</span>
              </Grid>
              <Grid item>
                <strong>
                  {order3PL?.price?.toString()?.concat(' ', 'تومان')}
                </strong>
              </Grid>
            </Grid>
            {driver.name && (
              <Grid
                style={{ margin: '5px 0' }}
                container
                justify="space-between"
                alignItems="center"
              >
                <Grid item>
                  <span>{'نوع پرداخت'}</span>
                </Grid>
                <Grid item>
                  <span style={{ color: '#4aa8ff' }}>
                    {driver.paymentType === 'CREDIT' ? 'اعتباری' : 'نقدی'}
                  </span>
                </Grid>
              </Grid>
            )}
            {(!driverStatus ||
              driverStatus === 'CANCELLED' ||
              driverStatus === 'NOT_REGISTERED' ||
              driverStatus === 'SEARCHING_COURIER_EXPIRED' ||
              driverStatus === 'REQUESTED_TO_CANCEL') && (
                <Button
                  type="button"
                  onClick={handlerDriver}
                  className={classes.requestButton}
                  aria-label="search"
                >
                  {'درخواست پیک'}
                </Button>
              )}
            <Divider className={classes.divider} />
            {driver.name && (
              <Grid
                style={{ margin: 0 }}
                container
                justify="space-between"
                alignItems="center"
              >
                <Grid item>
                  <span>{'مدت زمان تقریبی سفر'}</span>
                </Grid>
                <Grid item>
                  <strong>
                    {driver.timeToDeliver?.toString()?.concat(' ', 'دقیقه')}
                  </strong>
                </Grid>
              </Grid>
            )}
            {(driverStatus === 'REGISTERED_IN_3PL' ||
              driverStatus === 'SEARCHING_COURIER') && (
                <Button
                  style={{ marginTop: '20px' }}
                  onClick={cancel3PLRequest}
                  fullWidth
                  color="secondary"
                  variant="contained"
                >
                  {'لغو سفر'}
                </Button>
              )}
            {hasSecondDestination && (
              <Button
                type="button"
                onClick={() => { }}
                className={classes.requestButton}
                aria-label="search"
              >
                {'تایید'}
              </Button>
            )}
          </form>
        </Grid>
      </Grid>

      <Modal
        maxWidth="sm"
        onClose={() => setOpenAlopeykRequest(false)}
        open={openAlopeykRequest}
        title={''}
        content={
          <Grid
            container
            style={{ margin: 0, width: '300px' }}
            direction="column"
            spacing={4}
            alignItems="center"
            justify="center"
          >
            <Icon
              color="#4aa8ff"
              size={3}
              path={mdiLoading}
              spin={loadingDriver}
            />
            <h5 className="text-center">{'در حال پیدا کردن پیک'}</h5>
            <Button
              onClick={cancel3PLRequest}
              fullWidth
              color="secondary"
              variant="contained"
            >
              {'لغو درخواست'}
            </Button>
          </Grid>
        }
      />

      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت سفارش
        "${translate(props.order.status, 'order')}"
        به
       " ${translate(previewState.replace(/"/g, '') as Status, 'order')}"
    
        
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={changeStatusOrder}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog open={openDeleteItem} onClose={handleCloseDialog}>
        <DialogContent style={{ width: '600px' }}>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialog ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialog}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <p>
            آیا از لغو آیتم 3PL با شناسه
            <strong> {item.id} </strong> مطمئن هستید
          </p>
          <Grid container item xs={12} alignItems="flex-end">
            <div className={classes.item} style={{ width: '100%' }}>
              <span className={classes.label}>
                <Icon path={mdiText} size={1} className={classes.icon} />
              </span>

              <span style={{ width: '100%' }}>
                <TextField
                  fullWidth
                  id="description"
                  name="description"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  label="توضیحات"
                  className={classes.textInput}
                />
              </span>
            </div>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                onClick={cancelOrder3PL}
                variant="contained"
                color="secondary"
                size="large"
                fullWidth
                disabled={loading || !description}
              >
                {'بله'}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={handleCloseDialog}
                variant="contained"
                fullWidth
                autoFocus
              >
                {'خیر'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  order: makeSelectOrder(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({ id })),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
      callback?: () => void;
    }) => dispatch(updateOrderStatusActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(AlopeykRequest);
